import { IonContent, IonItem, IonLabel, IonModal } from "@ionic/react";
import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet";

const objectSets = [
    ["🍎", "🍌", "🍇"], ["🚗", "🚌", "🚲"], ["🏀", "⚽", "🏐"],
    ["🐶", "🐱", "🐭"], ["✈️", "🚁", "🚢"], ["🌞", "🌍", "🌊"],
    ["🎈", "🎁", "🎂"], ["🌲", "🌳", "🌿"], ["🏠", "🏢", "🏬"],
    ["📕", "📘", "📗"], ["🐘", "🦓", "🦒"], ["🍔", "🍟", "🥤"],
    ["🚀", "🛰", "🌍"], ["🎤", "🎸", "🥁"], ["🏕", "🔥", "🛶"],
    ["🚴", "🏍", "🚂"], ["🎭", "🎨", "🎬"], ["🦄", "🐉", "🐲"],
    ["🛸", "🛶", "🚤"], ["🦅", "🦆", "🐧"], ["🍓", "🍒", "🍉"],
    ["🐳", "🐬", "🐟"], ["🎯", "🎳", "🎮"], ["⚔️", "🛡", "🏹"],
    ["🔬", "📡", "💡"], ["🌵", "🍀", "🌻"], ["🛵", "🚜", "🚛"],
    ["🦖", "🦕", "🐢"], ["📱", "💻", "🖥"], ["🎺", "🎻", "🥁"],
    ["🧩", "♟", "🎲"], ["📖", "📚", "📰"], ["🌈", "☁️", "🌙"],
    ["🎠", "🎢", "🎡"], ["🍕", "🌮", "🍣"], ["🍩", "🧁", "🍪"],
    ["🥦", "🥕", "🌽"], ["🦜", "🦢", "🦉"], ["🏖", "🏔", "🏜"],
    ["🛳", "🚁", "🚀"], ["🗻", "🏕", "🏝"], ["🛶", "🚤", "⛵"],
    ["🎭", "🎷", "🎺"], ["⚽", "🏈", "🏀"], ["🎹", "🎻", "🎷"],
    ["🦋", "🐞", "🐛"], ["🔑", "🗝", "💰"], ["⚓", "⛵", "🚢"],
    ["🚦", "🚥", "🛑"], ["🏯", "🏰", "🕌"], ["🦊", "🐻", "🐺"],
    ["💎", "📿", "💰"], ["🦎", "🐍", "🐸"], ["🏎", "🚜", "🚛"],
    ["🌼", "🌷", "💐"], ["🎃", "🧛", "👻"], ["🛷", "⛸", "🎿"],
    ["🦆", "🦉", "🦜"], ["🍯", "🍵", "🥛"], ["🧀", "🥖", "🥚"],
    ["🦔", "🐇", "🦨"], ["🛶", "🚤", "🚢"], ["🦜", "🦢", "🦆"],
    ["🚁", "🛫", "🚀"], ["🍎", "🍐", "🍊"], ["🦉", "🐦", "🦜"],
    ["🎂", "🍪", "🧁"], ["🦖", "🦕", "🐢"], ["🧸", "🪀", "🎲"],
    ["📻", "📺", "🎧"], ["🎃", "🎄", "🎁"], ["🥄", "🍴", "🔪"],
    ["💎", "🔮", "⚱"], ["🎩", "👑", "🎓"], ["🌜", "🌞", "🌛"],
    ["🍓", "🍒", "🍉"], ["🚕", "🚙", "🚐"], ["🦁", "🐯", "🐻"],
    ["🎷", "🎸", "🎺"], ["🏅", "🥇", "🥈"], ["📏", "📐", "📎"],
    ["🏡", "🏢", "🏰"], ["🎠", "🎪", "🎢"], ["📷", "🎥", "📽"],
    ["🌵", "🌴", "🎋"], ["🥇", "🥈", "🥉"], ["🍵", "☕", "🥤"],
    ["🛶", "🚤", "⛴"], ["🦌", "🐗", "🐘"], ["🌻", "🌺", "🌼"],
    ["📀", "💽", "💾"], ["🔮", "🪄", "🎩"], ["🥋", "🎽", "🥊"],
    ["🚜", "🚛", "🚚"], ["🎠", "🎢", "🎡"], ["📍", "🧭", "🗺"],
    ["🌞", "🌚", "🌕"], ["🍎", "🍑", "🍏"], ["🚴", "🛹", "🛼"],
    ["🕹", "🎮", "📟"], ["🚁", "🛩", "✈️"], ["🦕", "🦖", "🦣"],
    ["🥑", "🍠", "🥔"], ["📻", "🎧", "📱"], ["🎭", "🎟", "🎬"],
    ["🏆", "🏅", "🥇"], ["📦", "🎁", "🛍"], ["🎸", "🎷", "🎺"],
    ["🎠", "🎡", "🎢"], ["📖", "📚", "📜"], ["🛷", "⛸", "🎿"],
    ["🌄", "🏞", "🗻"], ["📱", "💻", "🖥"], ["🍕", "🍔", "🌭"],
    ["🐠", "🐟", "🐡"], ["📅", "🗓", "📆"], ["📞", "📟", "📠"],
    ["🍚", "🍙", "🍘"], ["📊", "📈", "📉"], ["🎤", "🎧", "📻"],
    ["🚑", "🚒", "🚓"], ["🔬", "🔭", "🧪"], ["🔔", "🎵", "🎶"],
    ["🧩", "🃏", "🎴"], ["🌜", "🌞", "🌛"], ["🍀", "🌹", "🌷"],
    ["🏞", "🏕", "🏔"], ["🏄", "🏊", "🚣"], ["🛒", "🛍", "🎁"],
    ["📯", "🎺", "🎷"], ["📹", "🎥", "📽"], ["🏗", "🏠", "🏢"],
    ["🔑", "🗝", "💰"], ["🦈", "🐋", "🐊"], ["🍵", "☕", "🥤"],
    ["🌵", "🌴", "🎋"], ["🏔", "🗻", "🏞"], ["📞", "📟", "📠"],
    ["🍀", "🌿", "☘"], ["🎖", "🏅", "🥇"], ["🏝", "🏜", "🏞"],
    ["🎠", "🎡", "🎢"], ["🍉", "🍓", "🍇"], ["🎙", "🎤", "🎧"]
];


const AboveMiddleBelowGame: React.FC = () => {
    const [question, setQuestion] = useState("");
    const [correctAnswer, setCorrectAnswer] = useState("");
    const [message, setMessage] = useState("");
    const [currentObjects, setCurrentObjects] = useState<string[]>([]);
    const [showImage, setShowImage] = useState(false);
    const modal = useRef<HTMLIonModalElement>(null);

    useEffect(() => {
        generateQuestion();
        document.title = "Above, Middle, Below Worksheets for UKG | Spatial Position Activities";
    }, []);

    const generateQuestion = () => {
        const randomSet = objectSets[Math.floor(Math.random() * objectSets.length)];
        setCurrentObjects(randomSet);

        const randomType = Math.random();
        let newQuestion = "";
        let correct = "";

        if (randomType < 0.33) {
            newQuestion = `Choose the object above ${randomSet[1]}.`;
            correct = randomSet[0];
        } else if (randomType < 0.66) {
            newQuestion = `Choose the object below ${randomSet[1]}.`;
            correct = randomSet[2];
        } else {
            newQuestion = `Choose the object in the middle.`;
            correct = randomSet[1];
        }

        setQuestion(newQuestion);
        setCorrectAnswer(correct);
    };

    const checkAnswer = (selected: string) => {
        if (selected === correctAnswer) {
            setShowImage(true);
            setTimeout(() => {
                generateQuestion()
                setShowImage(false);
                setMessage("")
            }, 5000)
        } else {
            setShowImage(false);
            setMessage("❌ Oops! Try again.");
        }
    };

    return (
        <>
            <Helmet>
                <meta name="description" content="Help UKG kids learn spatial positioning with Above, Middle, and Below activities. Download fun and free worksheets to build early observation skills." />
                <link rel="canonical" href="https://mamasguidance.com/ukg/mathematics/pre-math-concepts/above-middle-below" />
            </Helmet>
            {
                showImage === false ?
                    <>
                        <div className="contentPart additionWord pickColor matchImage match-container" style={{ textAlign: "center", padding: "20px" }}>
                            <div className="showInfo" style={{ width: '80%' }} onClick={() => modal.current?.present()}><i className="fas fa-info-circle"></i></div>
                            <IonModal
                                ref={modal}
                                trigger="open-modal"
                                initialBreakpoint={1}
                                breakpoints={[0, 0.5, 0.75, 1]}
                                handleBehavior="cycle"
                                backdropDismiss={false}  // ✅ Prevents click-to-close
                                className="full-page-modal"
                            >
                                <IonContent className="ion-padding">
                                    <div style={{ textAlign: 'right', fontSize: '25px' }} onClick={() => modal.current?.dismiss()}><i className="fas fa-3a fa-times"></i></div>
                                    <h1>Above, Middle, Below</h1>

                                    <p>
                                        Teaching children how to identify the position of objects is an important part of <strong>pre-math learning</strong>. The spatial concepts of <strong>above</strong>, <strong>middle</strong>, and <strong>below</strong> help UKG students describe where things are located. Mama’s Guidance offers interactive worksheets that make learning fun and visual for young learners.
                                    </p>

                                    <h2>📌 What Are Above, Middle, and Below?</h2>
                                    <ul>
                                        <li><strong>Above:</strong> Something is placed higher or on top of another object.</li>
                                        <li><strong>Middle:</strong> Something is between two other objects or in the center.</li>
                                        <li><strong>Below:</strong> Something is placed underneath or lower than another object.</li>
                                    </ul>

                                    <p>
                                        For example:
                                        – The star is <strong>above</strong> the tree.
                                        – The apple is in the <strong>middle</strong> of two oranges.
                                        – The ball is <strong>below</strong> the table.
                                    </p>

                                    <h2>🎯 Learning Objectives</h2>
                                    <ul>
                                        <li>Recognize and identify positions like above, middle, and below</li>
                                        <li>Develop observation and visual discrimination skills</li>
                                        <li>Understand order and placement through real-life examples</li>
                                        <li>Use position words correctly in conversation</li>
                                    </ul>

                                    <h2>🖍️ Worksheet Highlights</h2>
                                    <ul>
                                        <li>Circle the object that is above, in the middle, or below</li>
                                        <li>Match pictures to the correct positional word</li>
                                        <li>Color the object that is in the middle of the row</li>
                                        <li>Drag and place activity for digital learners</li>
                                        <li>Cut-and-paste sorting worksheets</li>
                                    </ul>

                                    <h2>👨‍🏫 Tips for Teaching at Home or School</h2>
                                    <ul>
                                        <li>Use toys or everyday items (books, cups, pillows) to demonstrate position</li>
                                        <li>Give verbal instructions like <strong>“Place the spoon above the plate”</strong></li>
                                        <li>Encourage children to describe scenes: <strong>“What is in the middle of the picture?”</strong></li>
                                        <li>Use fun songs and games that reinforce spatial awareness</li>
                                    </ul>


                                    <h2>🔗 Related Topics</h2>
                                    <div>
                                        <IonItem routerLink="/ukg/mathematics/pre-math-concepts/long-short"
                                            routerDirection="none"
                                            lines="none"
                                            detail={true}>
                                            <IonLabel>Long - Short</IonLabel>
                                        </IonItem>
                                        <IonItem routerLink="/ukg/mathematics/pre-math-concepts/heavy-light"
                                            routerDirection="none"
                                            lines="none"
                                            detail={true}>
                                            <IonLabel>Heavy - Light</IonLabel>
                                        </IonItem>
                                        <IonItem routerLink="/ukg/mathematics/pre-math-concepts/front-back"
                                            routerDirection="none"
                                            lines="none"
                                            detail={true}>
                                            <IonLabel>Front - Back</IonLabel>
                                        </IonItem>
                                    </div>

                                    <h2>🌟 Mama’s Guidance Tip</h2>
                                    <p>
                                        Use a <strong>“Position Hunt”</strong> activity: ask your child to find something <strong>“above the chair”</strong> or <strong>“in the middle of the shelf”</strong> — fun, real-world practice works best!
                                    </p>

                                    <div className="btn hero-btn" onClick={() => modal.current?.dismiss()}>Close</div>
                                </IonContent>
                            </IonModal>
                            <article className="visually-hidden">
                                <h1>Above, Middle, Below</h1>

                                <p>
                                    Teaching children how to identify the position of objects is an important part of <strong>pre-math learning</strong>. The spatial concepts of <strong>above</strong>, <strong>middle</strong>, and <strong>below</strong> help UKG students describe where things are located. Mama’s Guidance offers interactive worksheets that make learning fun and visual for young learners.
                                </p>

                                <h2>📌 What Are Above, Middle, and Below?</h2>
                                <ul>
                                    <li><strong>Above:</strong> Something is placed higher or on top of another object.</li>
                                    <li><strong>Middle:</strong> Something is between two other objects or in the center.</li>
                                    <li><strong>Below:</strong> Something is placed underneath or lower than another object.</li>
                                </ul>

                                <p>
                                    For example:
                                    – The star is <strong>above</strong> the tree.
                                    – The apple is in the <strong>middle</strong> of two oranges.
                                    – The ball is <strong>below</strong> the table.
                                </p>

                                <h2>🎯 Learning Objectives</h2>
                                <ul>
                                    <li>Recognize and identify positions like above, middle, and below</li>
                                    <li>Develop observation and visual discrimination skills</li>
                                    <li>Understand order and placement through real-life examples</li>
                                    <li>Use position words correctly in conversation</li>
                                </ul>

                                <h2>🖍️ Worksheet Highlights</h2>
                                <ul>
                                    <li>Circle the object that is above, in the middle, or below</li>
                                    <li>Match pictures to the correct positional word</li>
                                    <li>Color the object that is in the middle of the row</li>
                                    <li>Drag and place activity for digital learners</li>
                                    <li>Cut-and-paste sorting worksheets</li>
                                </ul>

                                <h2>👨‍🏫 Tips for Teaching at Home or School</h2>
                                <ul>
                                    <li>Use toys or everyday items (books, cups, pillows) to demonstrate position</li>
                                    <li>Give verbal instructions like <strong>“Place the spoon above the plate”</strong></li>
                                    <li>Encourage children to describe scenes: <strong>“What is in the middle of the picture?”</strong></li>
                                    <li>Use fun songs and games that reinforce spatial awareness</li>
                                </ul>


                                <h2>🔗 Related Topics</h2>
                                <div>
                                    <IonItem routerLink="/ukg/mathematics/pre-math-concepts/long-short"
                                        routerDirection="none"
                                        lines="none"
                                        detail={true}>
                                        <IonLabel>Long - Short</IonLabel>
                                    </IonItem>
                                    <IonItem routerLink="/ukg/mathematics/pre-math-concepts/heavy-light"
                                        routerDirection="none"
                                        lines="none"
                                        detail={true}>
                                        <IonLabel>Heavy - Light</IonLabel>
                                    </IonItem>
                                    <IonItem routerLink="/ukg/mathematics/pre-math-concepts/front-back"
                                        routerDirection="none"
                                        lines="none"
                                        detail={true}>
                                        <IonLabel>Front - Back</IonLabel>
                                    </IonItem>
                                </div>

                                <h2>🌟 Mama’s Guidance Tip</h2>
                                <p>
                                    Use a <strong>“Position Hunt”</strong> activity: ask your child to find something <strong>“above the chair”</strong> or <strong>“in the middle of the shelf”</strong> — fun, real-world practice works best!
                                </p>
                            </article>
                            <h2>{question}</h2>
                            <div className="optionImageDiv" style={{ margin: "20px 0" }}>
                                {currentObjects.map((object, index) => (
                                    <div key={index} style={{ cursor: "pointer" }} onClick={() => checkAnswer(object)}>
                                        {object}
                                    </div>
                                ))}
                            </div>
                            <p>{message}</p>
                        </div>
                    </>
                    :
                    <>
                        <div className="contentPart showMiddle">
                            <img style={{ height: '150px' }} className='img-fluid' src={process.env.REACT_APP_WELDONE_LINK} />
                        </div>
                    </>
            }
        </>
    );
};

export default AboveMiddleBelowGame;
